module.exports = "/_next/static/images/p_tri-1d3e6473ef211f7959a2b2fb3e9ae091.png";